import React, { useEffect, useRef, useState } from 'react'
import { Col, FlexboxGrid } from 'rsuite'
import PortalHeader from '../components/layout/PortalHeader'
import UsersLicensesWrapper from '../components/dashboard/UsersLicenses/UsersLicensesWrapper'
import ActionsList from '../components/dashboard/actions/actionsList'
import { useDispatch } from 'react-redux'
import { resetTaxState } from '../store/slices/tax/taxSlice'
//import { selectUsersLicenses } from '../store/slices/dashboard/dashboardSelectors'
import { resetPaymentState } from '../store/slices/payment/paymentSlice'
import { resetLicenseViewState } from '../store/slices/licenseView/licenseViewSlice'
import { resetWorkProgressState } from '../store/slices/auth/authSlice'
import { resetApplyState } from '../store/slices/apply/applySlice'
import { resetUpdateState } from '../store/slices/update/updateSlice'
import { resetRenewState } from '../store/slices/renew/renewSlice'
import { clearAllPersistedStateExceptAuth } from '../common/tokenPersistence'


const Dashboard = () => {
    const dispatch = useDispatch();
    const [rerenderActionsList, setRerenderActionsList] = useState(0);

    const actionsListRef = useRef(null);
    const usersLicensesWrapperRef = useRef(null);

    useEffect(() => {
        dispatch(resetTaxState());
        dispatch(resetPaymentState());
        dispatch(resetLicenseViewState());
        dispatch(resetApplyState());
        dispatch(resetUpdateState());
        dispatch(resetRenewState());
        dispatch(resetWorkProgressState());
        clearAllPersistedStateExceptAuth();
    }, [dispatch])

    const onLicenseWrapperSizeCalculated = () => {
        setRerenderActionsList(prev => prev + 1);
    }

    return (
        <FlexboxGrid justify='space-between'>
            <FlexboxGrid.Item colspan={24}>
                <PortalHeader title="Dashboard" />
            </FlexboxGrid.Item>

            <FlexboxGrid.Item as="main" role="main" className="ph-24 pb-24 mt-20 sm-mt-0 sm-page-padding" colspan={24}>
                <FlexboxGrid role="grid" justify='space-between'>
                    <FlexboxGrid.Item role="row" className="ph-24 sm-ph-0 pb-32" as={Col} colspan={24} md={12} lg={14} ref={actionsListRef}>
                        <div role="cell">
                            <ActionsList 
                                usersLicensesWrapperRef={usersLicensesWrapperRef} 
                                forceRerender={rerenderActionsList}
                            />
                        </div>
                    </FlexboxGrid.Item>

                    <FlexboxGrid.Item role="row" className="ph-24 sm-ph-0 pb-32" as={Col} colspan={24} md={12} lg={10}>
                        <div role="cell">
                            <UsersLicensesWrapper 
                                ref={usersLicensesWrapperRef} 
                                onSizeCalculated={onLicenseWrapperSizeCalculated}
                            />
                        </div>
                    </FlexboxGrid.Item>

                    {/* <FlexboxGrid.Item className="ph-24 mt-24" as={Col} colspan={24}>
                   
                        <Stack className="pv-8 ph-16" style={{border: "1px solid #C4C4C4", borderRadius: '8px'}} direction="column" justifyContent="flex-start" alignItems='flex-start'>
                            <Stack.Item>
                                <Text className="text-large text-bold">Reporting History</Text>
                            </Stack.Item>
                            <Stack.Item>

                            </Stack.Item>
                        </Stack>
                    </FlexboxGrid.Item> */}
                </FlexboxGrid>
            </FlexboxGrid.Item>
        </FlexboxGrid>
    )
}

export default Dashboard
